import { toast } from 'sonner';
import { LANGUAGE_TABS } from '../../constants/languages.constants';
import type { LanguageCode } from '../../types/entryRules.types';
import { cn } from '@/shared/utils/cn';

interface LanguageTabsProps {
  active: LanguageCode;
  onChange: (lang: LanguageCode) => void;
  disabled: boolean;
}

export function LanguageTabs({ active, onChange, disabled }: LanguageTabsProps) {
  const handleClick = (code: LanguageCode) => {
    if (code === active) return;
    if (disabled) {
      toast.warning('Сохраните все карточки перед переключением языка');
      return;
    }
    onChange(code);
  };

  return (
    <div className="flex gap-1 border-b border-gray-200">
      {LANGUAGE_TABS.map((tab) => (
        <button
          key={tab.code}
          onClick={() => handleClick(tab.code)}
          className={cn(
            'px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px',
            tab.code === active
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
